import { render } from "./MonitoringUserForm.vue?vue&type=template&id=beb05662"
import script from "./MonitoringUserForm.vue?vue&type=script&lang=js"
export * from "./MonitoringUserForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__